export enum FrageEingeschraenkt {
  KEINE = 'keine',

  LEICHT = 'leicht',

  STARK = 'stark',
}
